module.exports = __webpack_public_path__ + "static/media/copy-text-instructions.1ee531d9.svg";